/* eslint-disable react-hooks/exhaustive-deps */

// React
import { useContext, useEffect } from "react"

// Components
import { Select } from "components"

// Contexts
import { DataJournalContext } from "contexts"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Utils
import { DetailFormType } from "../../../utils"

export function Tax() {
  // Hooks
  const { tax_code: { data, isReloading } } = useContext(DataJournalContext)

  // Form
  const { control, setValue } = useFormContext<DetailFormType>()

  useEffect(() => {
    if (data) {
      setValue("tax_id", data.find(item => item.rate === 0)?.value ?? "")
    }
  }, [data])

  return (
    <Controller
      control={control}
      name="tax_id"
      render={({ field, fieldState }) => (
        <Select
          placeholder="Select Tax"
          error={fieldState.error?.message}
          isLoading={isReloading}
          options={data}
          ref={field.ref}
          value={data.find(item => item.value === field.value) ?? null}
          onChange={item => field.onChange(item?.value)}
        />
      )}
    />
  )
}